import { faRotateLeft } from '@fortawesome/free-solid-svg-icons'
import type { FC } from 'react'
import { useState } from 'react'

import IconButton from '@/components/IconButton'
import ResetSectionPanel from '@/components/ResetSectionsPanel'
import type { Application } from '@/types/Activity'

interface Props {
  application: Application
  customerId: string
  applicationId: string
  subjectId: string
  disabled?: boolean
}

const ResetSections: FC<Props> = ({
  customerId,
  applicationId,
  subjectId,
  application,
  disabled = false,
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState<boolean>(false)

  return (
    <>
      {isSidebarOpen && (
        <ResetSectionPanel
          application={application}
          subjectId={subjectId}
          applicationId={applicationId}
          customerId={customerId}
          onClose={() => setIsSidebarOpen(false)}
        />
      )}
      <IconButton
        tooltipMessage="Reset sections"
        icon={faRotateLeft}
        onClick={() => setIsSidebarOpen(true)}
        disabled={disabled}
      />
    </>
  )
}

export default ResetSections
